import React from 'react';

import Nav from '../Nav/Nav';


const header = () => {
  return (
    <div className='header'>
     
      <Nav />
    </div>
  );
};

export default header;
